import React from 'react'
import { WidgetState } from './api'
import LiveUtils from 'live/lib/utils'
import MapWidget from './MapWidget'
import { reactWidgetWrapper } from 'live/widgets/decorators/react'
import widgetService from 'live/services/widgets'
import { mapWidgetReducer } from './MapWidget/mapWidgetReducer'
import { useThemeContext } from '@intelie/ui'

function MapsWidget({
    state,
    width,
    height
}: {
    state: WidgetState
    width: number
    height: number
}): React.ReactElement {
    const {
        theme: { themeName }
    } = useThemeContext()

    return state.batch.length ? (
        <MapWidget
            dashTheme={themeName}
            batch={state.batch}
            meta={state.meta}
            height={height}
            width={width}
            isMobile={LiveUtils.isMobile()}
        />
    ) : null
}

MapsWidget.policies = {
    defaultReducer: '@latest'
}

const widgetImpl = reactWidgetWrapper(MapsWidget, mapWidgetReducer)

widgetService.register({
    name: 'Assets Map',
    type: 'assets-map',
    config: {},
    policies: {
        layers: 1
    },
    description: 'Map widget with markers dedicated to assets',
    impl: widgetImpl
})
